import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MonexUltra2Service} from '../../lib/services/monex-ultra-2/monex-ultra2.service';
import {firstValueFrom} from 'rxjs';
import {ValidationTermsAndCondition} from '../../lib/models/monex-ultra.model';
import {ToastService} from '../../lib/services/toast/toast.service';
import {SystemAuthenticationService} from "@monex-sistemas/nueva-banca-digital-library";
import * as pubsub from "pubsub-js"
import {JwtService} from "../../lib/services/jwt/jwt.service";
import {ValidateTokenService} from "../../lib/services/validate-token/validate-token.service";

@Component({
  selector: 'app-monex-ultra2',
  templateUrl: './monex-ultra2.component.html',
  styleUrls: ['./monex-ultra2.component.scss']
})
export class MonexUltra2Component implements AfterViewInit, OnInit, OnDestroy {
  modalRef: NgbModalRef;
  referenceNumber: string;
  translations: any;
  userAlreadyAcceptTC: ValidationTermsAndCondition;
  checked: boolean = false;
  loading: boolean = false;
  otpCode: string = "";
  tokenStatus: boolean = false
  @ViewChild('scrollContainer') scrollContainer: ElementRef

  constructor(
    private monexUltra2Service: MonexUltra2Service,
    private toastService: ToastService,
    private elementRef: ElementRef,
    private systemAuthService: SystemAuthenticationService,
    private checkStatusService: ValidateTokenService,
    private jwtService: JwtService
  ) { }

  ngOnInit() {

    pubsub.subscribe("MONEX_ULTRA_VALID_TOKEN_TERM_AND_CONDITIONS", async (msg: any, data: any) => {
      let tokenStatus;
      try {
        tokenStatus = await this.checkStatusService.checkTokenStatus();

      } catch (error) {
        console.log(error)
        data.modalRef.close();
        return
      }

      if (tokenStatus) {
        console.log(data)
        data.modalRef.close();
        this.otpCode = data?.token;
        this.tokenStatus = false;
        await this.acceptTermsAndConditions()
      }
    })
  }

  ngAfterViewInit(): void {
    this.scrollContainer.nativeElement.scrollTop = 0;
    setTimeout(() => {
      const el = document.querySelector("#scroll-container")
      if (el) el.scrollTop = 0
    })
  }

  closeModal() {
    this.modalRef.close();
  }

  async acceptTermsAndConditions() {
    pubsub.unsubscribe('MONEX_ULTRA_VALID_TOKEN_TERM_AND_CONDITIONS')
    this.loading = true
    let res
    let jwt = this.buildRequest(this.referenceNumber); //('2063576')
    try {
        res = await firstValueFrom(this.monexUltra2Service.acceptTermsAndCondicions(jwt));
    } catch (error) {
      this.loading = false
      console.log(error);
      return;
    }

    await this.validateUserAlreadyAcceptTC(this.referenceNumber);
    this.loading = false

    if (res.error === 3) {
      this.toastService.showToast(this.translations.ALREADY_ACCEPT_TYC, "warn", "Monex Ultra");
      this.closeModal()
      return
    }

    if (!this.userAlreadyAcceptTC.guid) {
      this.toastService.showToast(this.translations.GUID_ERROR, "error", "Monex Ultra");
      return;
    }

    this.closeModal();
    this.openMonexUltraUrl(this.userAlreadyAcceptTC.guid);
  }

  async validateUserAlreadyAcceptTC(contractReferenceNumber: string): Promise<any> {
    try {
      let jwt = this.buildRequest(contractReferenceNumber);
      this.userAlreadyAcceptTC = await firstValueFrom(this.monexUltra2Service.validateUserAlreadyAcceptTC(jwt));
    } catch (error) {
      this.toastService.showToast("Ocurrio un error al obtener la informacion, Intente de nuevo mas tarde", "warn", "Monex Ultra")
      console.log(error)
      return error;
    }
  }

  validToken(){
    this.closeModal();
    this.systemAuthService.openValidationToken("MONEX_ULTRA_VALID_TOKEN_TERM_AND_CONDITIONS");
  }


  openMonexUltraUrl(guid: string) {
    const url = "https://monex.fx.com/client/#!/login?lang=es&guid=" + guid
    window.open(url, '_blank')
  }

  ngOnDestroy() {

  }

  buildOperation(refNumContrato :any){
    return {
      refNumContrato: refNumContrato
    };
  }

  buildRequest(refNumContrato :any) {
    let operation = this.buildOperation(refNumContrato)
    return  this.generateRequestJwt({
      ...operation,
      otpCode: this.otpCode
    })
  }

   generateRequestJwt(payload: any){
    const { otpCode, ...rest} = payload
     return this.jwtService.signRequest("operacion", rest, otpCode)
  }

  closeModalWithUnsubscribe() {
    pubsub.unsubscribe('MONEX_ULTRA_VALID_TOKEN_TERM_AND_CONDITIONS');
    this.closeModal();
  }
}
